import immutable from 'seamless-immutable';
import { createReducer, completeReducer, completeState } from 'redux-recompose';

import { actions } from './actions';

const defaultState = completeState({
  storeById: {},
  updateStore: null,
  stores: [],
  allStores: { page: [] }
});

const reducerDescription = {
  primaryActions: [actions.GET_STORE_BY_ID, actions.UPDATE_STORE, actions.GET_STORES, actions.GET_ALL_STORES]
};

const reducer = createReducer(immutable(defaultState), completeReducer(reducerDescription));
export default reducer;
